var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"login-page"},[_c('div',{staticClass:"login-page-header"},[_c('img',{attrs:{"src":require("../assets/logo.png")}}),_c('span',[_vm._v(_vm._s(_vm.globalConfig.title))])]),_c('div',{staticClass:"login-page-body"},[_c('reset-password-form')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }